import React, { useRef } from "react";
import Header from "../Components/Header";
import HeroSection from "./Hero";
import Partners from "./Partners";
import Solutions from "./Solutions";
import Platform from "./Platform";
import DigitalAssets from "./DigitalAssets";
import Icon from "./IconWalking";
import Commitment from "./Commitment";
import Footer from "../Components/Footer";
import DeploymentSection from "./Deployment";
// import ExcrowTes from "./tesXcrowSection";
import CTASection from "../AboutUs/CtaSection";
import InformationPopup from "./InformationPopup";
// import RegulationPopUp from "./RegulationPopUp";

function TennetHome() {
  const heroRef = useRef(null); // Ref untuk HeroSection

  return (
    <div>
      <Header heroRef={heroRef} />
      <main>
        {/* <RegulationPopUp /> */}
        <InformationPopup />  {/* Tambahkan komponen InformationPopup */}
        <HeroSection ref={heroRef} /> {/* Terima prop ref */}
        <Partners />
        <Solutions />
        <Commitment />
        <Platform />
        <DigitalAssets />
        <Icon />
        { /* <DeploymentSection /> */ }
        {/* <ExcrowTes /> */}
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default TennetHome;
